"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationTypes = void 0;
var PaginationTypes;
(function (PaginationTypes) {
    PaginationTypes["Orders"] = "Orders";
    PaginationTypes["EventWaitList"] = "EventWaitList";
    PaginationTypes["EventOrders"] = "EventOrders";
    PaginationTypes["CustomerOrders"] = "CustomerOrders";
    PaginationTypes["Events"] = "Events";
    PaginationTypes["Artists"] = "Artists";
    PaginationTypes["Venues"] = "Venues";
    PaginationTypes["PlateformSettings"] = "PlateformSettings";
    PaginationTypes["OrganizationSettings"] = "OrganizationSettings";
    PaginationTypes["EventSettings"] = "EventSettings";
    PaginationTypes["Customers"] = "Customers";
    PaginationTypes["Organizations"] = "Organizations";
})(PaginationTypes = exports.PaginationTypes || (exports.PaginationTypes = {}));
//# sourceMappingURL=IPagination.js.map